function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useColorMode } from '@tempo/core';
import { initGDPRCallback, insertTCFScript } from './utils';
import { useRunOnce, usePrevious, createContext } from '@deezer/react-utils';
export const CookieBanner = (_param)=>{
    var { scriptUrl } = _param, props = _object_without_properties(_param, [
        "scriptUrl"
    ]);
    const { colorMode } = useColorMode();
    const { setConsentSettings } = useUserConsent();
    const previousProps = usePrevious(props);
    const previousColorMode = usePrevious(colorMode);
    useRunOnce(()=>{
        window.onDzrGDPRReady = (initApi)=>{
            initGDPRCallback(initApi, _object_spread_props(_object_spread({}, props), {
                darkMode: colorMode === 'dark',
                onConsentUpdate: setConsentSettings
            }));
        };
        insertTCFScript({
            id: 'gdpr-web-script',
            scriptUrl
        });
    });
    useEffect(()=>{
        if (previousProps && (previousProps.userID !== props.userID || previousProps.lang !== props.lang || previousColorMode !== colorMode)) {
            var _window_consentScreenApi;
            (_window_consentScreenApi = window.consentScreenApi) === null || _window_consentScreenApi === void 0 ? void 0 : _window_consentScreenApi.update({
                userID: props.userID,
                lang: props.lang,
                darkMode: colorMode === 'dark'
            });
        }
    }, [
        props.userID,
        previousProps,
        colorMode,
        props.lang,
        previousColorMode
    ]);
    return null;
};
export const ConsentContextProvider = ({ children })=>{
    const [consentSettings, setConsentSettings] = useState();
    return /*#__PURE__*/ _jsx(ConsentProvider, {
        value: {
            consentSettings,
            setConsentSettings
        },
        children: children
    });
};
const [ConsentProvider, useUserConsent] = createContext({
    name: 'Consent'
});
export { useUserConsent };

//# sourceMappingURL=CookieBanner.js.map